import type { ReactNode } from 'react';
import type { BadgeVariant } from '../../lib/status';

interface BadgeProps {
  variant?: BadgeVariant;
  children: ReactNode;
  title?: string;
}

/** Pill badge used for RFP statuses, vendor types and vendor statuses. */
export function Badge({ variant = 'neutral', children, title }: BadgeProps) {
  return (
    <span className={`badge badge--${variant}`} title={title}>
      {children}
    </span>
  );
}
